export default __webpack_public_path__ + "static/media/raw.b0e00055.svg";